import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import { API_ADDRESS, DATADOG_TOKEN, DEPLOYMENT_ENV, VERSION } from '@/constants/env';

export class DatadogManager {
  private static isEnabled() {
    return !!DATADOG_TOKEN;
  }

  public static init() {
    if (!this.isEnabled()) return;

    datadogRum.init({
      applicationId: '35e848fb-0673-40ab-8023-fcade5a46e30',
      clientToken: DATADOG_TOKEN,
      site: 'datadoghq.com',
      service: 'decorator',
      env: DEPLOYMENT_ENV,
      version: VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackResources: true,
      trackUserInteractions: true,
      trackLongTasks: true,
      allowedTracingUrls: [API_ADDRESS.replace(/\/$/, '')],
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin({ router: true })],
    });
  }

  public static setUser(user: { id: string; email: string; name?: string }) {
    if (!this.isEnabled()) return;
    datadogRum.setUser(user);
  }
}
